module.exports = __webpack_public_path__ + "static/roof.c1880759.svg";